export default "__VITE_ASSET__OIRRJXE6__"